import type { SalesTransactionDiscountType } from '@/api/models';

/**
 * GEL as every screen shows it (the sale point, Transactions, Shifts):
 * `₾ 3.85`. Shared here so a feature never imports another's internals.
 */
export const formatGel = (value: number): string => `₾ ${value.toFixed(2)}`;

/**
 * A discount as the seller entered it, for its tag: `10%`, `12.5%` or
 * `₾ 5.00`. Callers that mean "taken off" put the minus sign in front. Takes
 * the cart's discount and a stored sale's alike.
 */
export const formatDiscountValue = (discount: {
    type: SalesTransactionDiscountType;
    value: number;
}): string =>
    discount.type === 'percentage'
        ? `${discount.value}%`
        : formatGel(discount.value);
